import React from "react";
import { createRoot } from "react-dom/client";
import "./i18n";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import reportWebVitals from "./reportWebVitals";
import suppressNonCriticalWarnings from "./utils/suppressReactWarnings";

// ✅ PRAGMATIC FIX: Suppress non-critical Ant Design + React 18 warnings
suppressNonCriticalWarnings();

// ✅ CHUNK LOADING ERROR HANDLER: Auto-reload on chunk load failures
// Prevents "Loading chunk X failed" errors after deployments when users have stale HTML
const CHUNK_RELOAD_KEY = "chunk_reload_attempted";

window.addEventListener("error", (event) => {
	const isChunkLoadError =
		event.message?.includes("Loading chunk") ||
		event.message?.includes("Failed to fetch dynamically imported module") ||
		(event.error?.stack &&
			event.error.stack.includes("chunk") &&
			event.error.stack.includes("failed"));

	if (isChunkLoadError) {
		const hasReloadedBefore = sessionStorage.getItem(CHUNK_RELOAD_KEY);

		if (!hasReloadedBefore) {
			// Prevent infinite reload loops - only try once per session
			sessionStorage.setItem(CHUNK_RELOAD_KEY, "true");
			console.warn("Chunk load failed, reloading page to fetch latest chunks");
			window.location.reload();
		}
		// If flag exists, we already tried reloading - let error boundary handle it
		// Don't remove flag to prevent reload loop if error occurs again
	}
});

const container = document.getElementById("root");
const root = createRoot(container!); // createRoot(container!) if you use TypeScript
root.render(<App />);

serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
